module.exports = __webpack_public_path__ + "static/img/loading.589981a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 1